import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import totalEarned from "../../assets/totalearned.png";
import "./Totalearned.css";
import { Chip } from "@mui/material";
import { ApiCall, Colors } from "../../common/Const";
import arrow from "../../assets/arrow.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import moment from "moment";
import $ from "jquery";
import { toast, ToastContainer } from "react-toastify";
import store from "../../redux/Store";

import coins from "../../assets/coin.png";

const Totalearned = () => {
  const user = useSelector((state) => state.auth.user);
  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  const [coinsHistories, setCoinsHistories] = useState([]);
  const [modalTrue, setModalTrue] = useState(false);
  const [appsettings, setAppSettings] = useState([]);

  // const date = moment.now();
  const earnings = [
    {
      id: 1,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
    {
      id: 2,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
    {
      id: 3,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
  ];

  const creditHistory = () => {
    const walletParams = { customer_id: cusId };

    // console.log(walletParams);
    ApiCall("cwHistory", walletParams).then((data) => {
      if (data.message == "Success") {
        setCoinsHistories(data.result);
      }
    });
  };

  // console.log(coinsHistories);
  useEffect(() => {
    creditHistory();
  }, []);

  useEffect(() => {
    ApiCall("appsetting").then((data) => {
      if (data.message == "Success") {
        setAppSettings(data.result);
        // console.log(data.result);
      }
    });
  }, []);

  const handleProfileupdate = () => {
    const profileParams = { id: user.id };
    ApiCall("profileView", profileParams)
      .then((data) => {
        // console.log(data);
        if (data.message == "Success.") {
          store.dispatch({ type: "userupdate", payload: data.data });
        }
      })
      .catch((err) => console.log(err));
  };
  // console.log(user);
  const handleConvertCoins = () => {
    const convetCoinsParams = { customer_id: cusId };

    ApiCall("coinToWallet", convetCoinsParams).then((data) => {
      if (data.message == "Success.") {
        handleProfileupdate();
        creditHistory();
        toast.success(data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          limit: 1,
        });
        // console.log("success");
      }
    });
  };

  const handleNoAvailable = () => {
    toast.error("Coins not available", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      limit: 1,
    });
  };
  return (
    <>
      <Header make={true} />
      <div className="Wallet">
        {/* <span className="d-flex justify-content-center earnings_heading2">
          Earnings
        </span> */}
        <div className=" container d-flex align-items-center justify-content-evenly wa-center">
          <div className="">
            <a
              href="javascript:history.go(-1)"
              style={{ textDecoration: "none" }}
            >
              <button
                className="btn btn-sm backed"
                style={{
                  backgroundColor: Colors.Base_color,
                  color: "white",
                }}
              >
                <div className="d-flex align-items-center gap-2  back-div">
                  <i class="fa-solid fa-caret-left back-ar"></i>
                  <span style={{ paddingTop: "1px" }} className="back-text">
                    Back
                  </span>
                </div>
              </button>
            </a>
          </div>
          <span className="earnings_heading2 mx-2 justify-content-center">
            Coins Earned
          </span>
        </div>
        {/* <div className="banner_image2 image-fluid d-flex align-items-center justify-content-center"> */}

        {/* </div> */}
        {/* <div className="Total-rewards"> */}
        <div className="container Total-reward">
          <div className="row justify-content-center align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-7 ">
              <div className="center_small_banners2">
                <div className="center_small_banners">
                  {/* <div className="d-flex flex-column"> */}
                  {/* <span className="total_reward">Total Rewards</span> */}
                  <img src={coins} className="totalearneds"></img>
                  <span className="amountses"> {user.coins} Coins</span>
                  {/* </div> */}
                  <div
                    className="d-flex justify-content-around align-items-center chip"
                    style={{ cursor: "pointer" }}
                  >
                    {user.coins != 0 ? (
                      <span
                        style={{ paddingRight: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#logout"
                      >
                        Redeem
                      </span>
                    ) : (
                      <span aria-disabled="true" onClick={handleNoAvailable}>
                        {" "}
                        Redeem
                      </span>
                    )}

                    {/* <ArrowDropDownIcon /> */}
                    <i class="fa-sharp fa-solid fa-arrow-right justify-content-center single-arrow-right"></i>
                  </div>
                </div>
                <hr className="hr"></hr>
                <div className="d-flex flex-column gap-1 text-collections ">
                  <div className="d-flex align-items-center">
                    <i class="fa-solid fa-circle circle-icone"></i>
                    <span className="refers">
                      {" "}
                      Refer Your Friends Earn ₹
                      {appsettings.referral_coins_newuser} coins
                    </span>
                    {/* <span className="refers">
                Earn ₹{appsettings.referral_coins_newuser} coins
              </span> */}
                  </div>
                  <div className="d-flex align-items-center">
                    <i class="fa-solid fa-circle circle-icone"></i>
                    <span className="refers">
                      For first purchase of referrer you get additional{" "}
                      {appsettings.referral_coins_first_purchase} coins
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center text-center des">
            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-7">
              {/* <span className="descri">
                You can convert you earned coins in to Wallet amount in any time
              </span> */}
            </div>
          </div>
          <div className="row justify-content-center align-items-center text-center pb-5 pt-3">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-7">
              <div className="d-flex justify-content-between">
                <span className="recent-earnings">Recent Earnings</span>
                {/* <span className="recent-earnings">Recent Earnings</span> */}
                {/* <Chip
                  label="Coins"
                  icon={<ArrowDropDownIcon style={{color:'white'}} />}
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                    cursor: "pointer",
                    gap:3
                  }}
                 
                /> */}
                {/* <div className="d-flex justify-content-around align-items-center chip">
                <span style={{paddingRight:"5px"}}>Coins</span>
                <ArrowDropDownIcon/>
               </div> */}
              </div>
              <hr className="hr"></hr>

              {coinsHistories.length != 0 && coinsHistories
                ? coinsHistories.coins_history.map((items) => {
                    return (
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column earnings">
                          <span style={{ color: "#126a38" }}>
                            {items.details}
                          </span>
                          <small className="text-start datesed">
                            {moment(items.created_at).format("YYYY/MM/DD")}
                          </small>
                        </div>
                        <span className="coinss" style={{ color: "#126a38" }}>
                          {items.transaction_coins}coins
                        </span>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
          <div
            class="modal fade"
            id="logout"
            tabindex="-1"
            aria-labelledby="logoutModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="btn-close"
                    id="closed"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body ">
                  <span
                    className="d-flex justify-content-center text-center"
                    style={{ color: "#126a38", fontSize: "1.0rem" }}
                  >
                    ₹
                    {appsettings && appsettings.coin_for_amt
                      ? appsettings.coin_for_amt * coinsHistories.last_credit
                      : ""}{" "}
                    will credit to your wallet, Are you sure want to redeem
                  </span>
                </div>
                <div className="modal-footer d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    class="btn"
                    id="closed"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{
                      color: "white",
                      backgroundColor: "#126a38",
                      fontFamily: "AvenirLTStdMedium",
                      width: "20%",
                    }}
                    onClick={handleConvertCoins}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn "
                    data-bs-dismiss="modal"
                    style={{
                      color: "white",
                      backgroundColor: "#126a38",
                      fontFamily: "AvenirLTStdMedium",
                      width: "20%",
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      <ToastContainer limit={1} />
      <Footer />
    </>
  );
};

export default Totalearned;
